import React from "react";
import "./patientMeasurement.scss";
import "../../steps/forms.scss";
import FormTitle from "../../components/formTitle/FormTitle";
import MuiRadio from "../../components/radio/MuiRadio";
import InputTextField from "../../components/textField/InputTextField";
import MuiDatePicker from "../../components/datePicker/MuiDatePicker";
import OrderFormStep from "../../common/OrderFormStep";
import FieldState from "../../common/FieldState";
import Config from "../../common/Config";
import axios from "axios";
import Button from "../../components/button/Button";
import SecondaryButton from "../../components/button/SecondaryButton";
import { Form } from "react-bootstrap";
import { CreateNotification } from "../../components/notification/Notification";
import SaveAsDraft from "../../components/modal/SaveAsDraft";
import { Button as MuiButton } from "@mui/material";
import { FileUploadIcon } from "../../icons/svg";

class TFRevoStandardMeasurement extends OrderFormStep {
  constructor(props) {
    super(props);

    this.fromCADFileId = 111;

    this.uomMetric = 67;
    this.uomImperial = 68;
    this.conversionFactor = 25.4;

    this.shortenId = 29;
    this.extendId = 30;

    this.nextCartQueueIndex=0;
    this.displayedCartIndex=0;

    this.defaults = {
      socketFinish: {name: "Carbon Finish", id: 20},
      insert: {name: "Black Flexible Inner", id: 177},
      revoFit: {name: "Posterior Gap", id: 161},
    }; 

    this.state = {
      // shapeCreations: [],
      // socketStyles: [],
      // trimlines: [],
      // modifications: [],
      estimatedShipDate: null,
      socketMaterials: [],
      locks: [],
      UOMs: [],
      isSubmit: false,
      selectedValue: 0,
      formState: {
        cadFile: new FieldState(false),
        cadFileName: new FieldState(false),
        castShippedSeparately: new FieldState(false),
        scanFileName: new FieldState(false),
        socketMaterial: new FieldState(true),
        lock: new FieldState(true),
        
        itemsSentIn: new FieldState(true),
        notes: new FieldState(false),
      },
    };

    this.onFileChange = this.onFileChange.bind(this);
    this.onCheckChange = this.onCheckChange.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.getNextCartQueueIndex = this.getNextCartQueueIndex.bind(this);
    this.shouldDisplayCart = this.shouldDisplayCart.bind(this);
  }

  getNextCartQueueIndex() {
    return this.nextCartQueueIndex++;
  }

  shouldDisplayCart(index) {
    if(index >= this.displayedCartIndex) {
      this.displayedCartIndex = index;
      return true;
    }

    return false;
  }

  
  loadCart() {
    let cart = [];

    let addToCart = (options, selectedId, sourceId) => {
      let item = options.filter(x => x.id===selectedId)[0];
      if(item && item.partNumbers && item.partNumbers.length > 0) {
        item.partNumbers.forEach(part => {
          cart.push({
            name: item.displayName,
            partNumber: part,
            quantity: 1,
            price: -1,
            sourceId: sourceId
          });
        });
      } else {
        cart.push({
            name: null,
            partNumber: null,
            quantity: 0,
            price: 0,
            sourceId: sourceId
          });
      }
    }

    addToCart(this.state.socketMaterials, this.state.formState.socketMaterial.value, "socketMaterial");
    addToCart(this.state.locks, this.state.formState.lock.value, "lock");
    
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    const index = this.getNextCartQueueIndex();

    return this.getFieldInputPromise()
      .then(r1 => {
        this.loadShipDate();
        return axios.get(
          Config.baseApiUrl + "price/" + this.props.formTypeId,
          config
        ).then(response => {
          let data = response.data
  
          cart = cart.map(c => {
            return {
              name: c.name,
              partNumber: c.partNumber,
              quantity: c.quantity,
              price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
              sourceId: c.sourceId
            }
          });

          cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
            return {
              name: d.name,
              partNumber: d.partNumber,
              quantity: d.quantity,
              price: d.price,
              sourceId: d.sourceId
            }
          }));
          
          if(this.shouldDisplayCart(index)) {
            this.props.setTempCart(cart);
          }
        }).catch(error =>{
          console.log(error)
        })
      });
  }

  handleAmountUnit = (e) => {
    this.setState({ unit: e.target.value });
    this.props.setActiveInnerStep(7);
  };

  handleAmountChange(e, value) {
    let formState = this.state.formState;
    formState.amount.value = e;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  // onRadioChange(e) {
  //   super.onRadioChange(e);

  //   let formState = this.state.formState;
  //   formState.cadFile.isRequired = this.isFromCADFileSelected();
  //   formState.scanFileName.isRequired = this.isFromScanSelected();
  //   this.setState({ formState: formState, hasDataChanged: true });
  // }

  onFileChange(e) {
    let formState = this.state.formState;

    formState.cadFile.value = this.renameFile(e.target.files[0]);
    formState.cadFileName.value = "";
    formState.cadFile.isRequired = this.isFromCADFileSelected();

    console.log(formState.cadFile)
    this.setState({ formState: formState, hasDataChanged: true });
  }

  renameFile(file) {
    const oldName = file.name;
    const oldFileType = oldName.split(".").slice(-1);
    const newName = crypto.randomUUID() + "." + oldFileType;

    return new File([file], newName);
  }

  isFromCADFileSelected() {
    return this.state.formState.socketMaterial === this.fromCADFileId;
  }

  onCheckChange(e) {
    let formState = this.state.formState;
    formState.castShippedSeparately.value = e.target.checked;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadShipDate() {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
      };
      let estimatedShipDate = (
        await axios.get(
          Config.baseApiUrl + "shipDate/" + this.props.formTypeId,
          config
        )
      ).data;

      this.setState({
        estimatedShipDate: estimatedShipDate,
      });
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }

  async loadData() {
    try {
      this.setState({
        socketMaterials: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "socketMaterial" } }
          )
        ).data,

        locks: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "lock" },
            }
          )
        ).data,

      });

      let formState = this.state.formState;

      let headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
      };
      let cadFileConfig = {
        headers: headers,
      };

      const cadFile = (
        await axios.get(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          cadFileConfig
        )
      ).data;
      formState.cadFileName.value = cadFile !== null ? cadFile.cadFileName : "";

      this.loadShipDate();
      let config = {
        headers: headers,
        params: {
          fieldNames: [
            "castShippedSeparately",
            "socketMaterial",
            "lock",
            "itemsSentIn",
            "notes",
          ],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );

      formState.castShippedSeparately.value = data.find(
        (fi) => fi.fieldName === "castShippedSeparately"
      ).booleanData;


      formState.socketMaterial.value = data.find(
        (fi) => fi.fieldName === "socketMaterial"
      ).fieldOptionId;

      formState.lock.value = data.find(
        (fi) => fi.fieldName === "lock"
      ).fieldOptionId;

      formState.itemsSentIn.value = data.find(
        (fi) => fi.fieldName === "itemsSentIn"
      ).stringData;
      formState.notes.value = data.find(
        (fi) => fi.fieldName === "notes"
      ).stringData;



      this.setState({ formState: formState });

      this.loadCart();
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }

    this.setState({ isLoaded: true });
  }

  getFieldInputPromise() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let fieldInputData = [];

    fieldInputData.push({
      fieldName: "castShippedSeparately",
      booleanData: this.state.formState.castShippedSeparately.value,
    });


    fieldInputData.push({
      fieldName: "socketMaterial",
      fieldOptionId: this.state.formState.socketMaterial.value,
    });

    fieldInputData.push({
      fieldName: "lock",
      fieldOptionId: this.state.formState.lock.value,
    });

    fieldInputData.push({
      fieldName: "socketFinish",
      fieldOptionId: this.defaults.socketFinish.id,
    });
    fieldInputData.push({
      fieldName: "insertMaterial",
      fieldOptionId: this.defaults.insert.id,
      booleanData: true,
    });
    fieldInputData.push({
      fieldName: "revoFit",
      fieldOptionId: this.defaults.revoFit.id,
      booleanData: true,
    });

    fieldInputData.push({
      fieldName: "itemsSentIn",
      stringData: this.state.formState.itemsSentIn.value,
    });

    fieldInputData.push({
      fieldName: "notes",
      stringData: this.state.formState.notes.value,
    });

    return axios.post(
      Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
      fieldInputData,
      config
    )
  }

  saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let promises = [];

    if (this.state.formState.cadFile.value !== "") {
      const formData = new FormData();

      formData.append(
        "cadFile",
        this.state.formState.cadFile.value,
        this.state.formState.cadFile.value.name
      );

      promises.push(
        axios.post(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          formData,
          config
        )
      );
    }


    if (this.validateData().isValid) {
      promises.push(this.getFieldInputPromise());
      axios
        .all(promises)
        .then(
          axios.spread((res, res2) => {
            if (res2) {
              if (
                (res.status === 200 || res.status === 204) &&
                (res2.status === 200 || res2.status === 204)
              ) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
                CreateNotification("Submitted", "success");
              }
            } else {
              if (res.status === 200 || res.status === 204) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
                CreateNotification("Submitted", "success");
              }
            }
          })
        )
        .catch((error) => {
          console.log(error);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");
      this.setState({ isLoading: false });
    }
  }

  handleSliderChange(newValue) {
    this.props.setActiveInnerStep(5);
  }

  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  convertToISOString(dateString) {
    const dateParts = dateString.split("-");
    const convertedDate = new Date(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2]
    );

    return convertedDate;
  }
  formatDateToString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    const cadFileUploader = (
      <div className="fileUpload">
          <MuiButton
            component="label"
            variant="contained"
            startIcon={<FileUploadIcon />}
          >
            Upload File
            <input
              type="file"
              style={{ display: "none" }}
              onChange={this.onFileChange}
            />
          </MuiButton>
          <span>{this.state.cadFileName?.value}</span>
        </div>
    );


    return (
      <div className="tfMeasuremnet">
        <div className="checkFormWrapper">
          <FormTitle
            title="Patient Measurement"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
              

            <div>
              <MuiRadio
                options={this.state.socketMaterials.map((option) => ({
                  displayName: option.displayName,
                  id: option.id,
                  partNumber: option.partNumber,
                  content: (option.id === this.fromCADFileId) ? cadFileUploader : ""
                }))}
                label="Socket Material"
                defaultValue={this.state.formState.socketMaterial.value}
                required={this.state.formState["socketMaterial"].isRequired}
                error={
                  this.handleError("socketMaterial") && this.state.isSubmit
                }
                onChange={(e) => {
                  this.props.setActiveInnerStep(2);
                  this.onRadioChange(e, "socketMaterial");
                }}
              />
            </div>

            <div className="fieldBorder">
              <MuiRadio
                options={this.state.locks}
                defaultValue={this.state.formState.lock.value}
                label="Lock"
                error={this.handleError("lock") && this.state.isSubmit}
                required={this.state.formState["lock"].isRequired}
                checked
                onChange={(e) => {
                  this.props.setActiveInnerStep(3);
                  this.onRadioChange(e, "lock");
                }}
              />
            </div>


            <div className="msgBox fieldBorder msgBoxWidth">
              <div className="possibelDate">
                <div>
                  <h4 className="headLable"><b>Earliest Ship Date</b>: {this.formatShipDate(this.state.estimatedShipDate)}</h4>
                </div>
              </div>
              <InputTextField
                label="Items sent in with socket"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.itemsSentIn.value}
                required={this.state.formState["itemsSentIn"].isRequired}
                error={this.handleError("itemsSentIn") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "itemsSentIn");
                  this.props.setActiveInnerStep(5);
                }}
              />
            </div>

            <div className="msgBox msgBoxWidth">
              <h4 className="headLable"> Notes</h4>
              <InputTextField
                label="Other Notes"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.notes.value}
                error={this.handleError("notes") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "notes");
                  this.props.setActiveInnerStep(6);
                }}
              />
            </div>

            <div className="fieldBorder">
              <div className="msgBox msgBoxWidth">
                <h4 className="headLable"><b>Socket Finish:</b></h4>
                <p>{this.defaults.socketFinish.name}</p>
              </div>
              <div className="msgBox msgBoxWidth">
                <h4 className="headLable"><b>Insert:</b></h4>
                <p>{this.defaults.insert.name}</p>
              </div>
              <div className="msgBox msgBoxWidth">
                <h4 className="headLable"><b>Revofit® Style:</b></h4>
                <p>{this.defaults.revoFit.name}</p>
              </div>
            </div>

            <div className="msgBox fieldBorder msgBoxWidth">
              <h4 className="headLable"><b>Revofit® Reel Placement</b></h4>
              <p>The reel will be positioned at the distal, anterior-medial aspect of the socket.
                The placement will blend naturally with the overall curve of the socket.
              </p>

              <h4 className="headLable"><b>Revofit® Gap Cutout Location & Size</b></h4>
              <p> The gap cutout will be positioned in the center of the posterior aspect of the socket.
                The shape resembles a keyhole, with the narrow part at the top.
                The narrowest part of the cutout will be ~1 inch (2.5 cm) wide.
                The opening will then widen to reveal the inner flexible liner of the socket.
                The length will extend distally to an appropriate depth that allows the socket to function 
                properly for limb compression. 
              </p>

              <p> <b>Important Note: </b>
                While we strive to follow these placement standards, the utimate location of the dial and window may be 
                adjusted slightly to ensure all components fit comfortably within the space limitations of your socket.
                This ensures optimal functionality and user experience.
              </p>
            </div>

          </form>
        </div>
        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
        
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                this.setState({ isLoading: true });
                this.saveData();
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
      </div>
    );
  }


  isPRSOption(option) {
    return option.includes("PRS");
  }

  isMMSelected() {
    return this.state.formState.prostheticHeightUOM.value === this.uomMetric;
  }
}

export default TFRevoStandardMeasurement;
